import { render, staticRenderFns } from "./PasswordOtp.vue?vue&type=template&id=4a83cf88"
import script from "./PasswordOtp.vue?vue&type=script&lang=ts"
export * from "./PasswordOtp.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports